import { useTranslation } from 'react-i18next';

interface ReservationDetailsSectionProps {
  keyType: 'physical_key_only' | 'digital';
}

/**
 * 予約詳細（注意事項・入室方法）セクションコンポーネント
 */
export const ReservationDetailsSection = ({
  keyType,
}: ReservationDetailsSectionProps) => {
  const { t } = useTranslation();

  return (
    <div className="f6__detail">
      {/* ご利用上の注意 */}
      <section className="f6__detail-box">
        <h3 className="f6__detail-title" id="f6-notice-title">
          {t('shareDevice.complete.notice.title')}
        </h3>
        <ul className="f6__list">
          <li className="f6__item">
            <span className="f6__item-color">
              {t('shareDevice.complete.notice.usageTime')}
            </span>
          </li>
          <li className="f6__item">
            {t('shareDevice.complete.notice.noExtension')}
            <br />
            {t('shareDevice.complete.notice.noExtensionDetail')}
            <br />
            <span className="f6__item-color">
              {t('shareDevice.complete.notice.noExtensionDetailContinuation')}
            </span>
          </li>
          <li className="f6__item">
            {t('shareDevice.complete.notice.autoCancellation')}
          </li>
        </ul>
      </section>

      {/* 入室方法 */}
      <section className="f6__detail-box">
        <h3 className="f6__detail-title" id="f6-enter-title">
          {t('shareDevice.complete.entry.title')}
        </h3>
        <ul className="f6__list">
          <li className="f6__item">
            {t('shareDevice.complete.entry.entryTime')}
          </li>
          <li className="f6__item">
            {keyType === 'physical_key_only'
              ? t('shareDevice.complete.entry.physicalKey')
              : t('shareDevice.complete.entry.digitalKey')}
          </li>
        </ul>
      </section>
    </div>
  );
};
